import { DynamicQuestion, SurveySection } from "./types";

export const FAMILY_BRANCHES = [
  'കുഞ്ഞബ്ദുല്ല ഹാജി',
  'അന്ത്രു ഹാജി',
  'മൊയ്തു ഹാജി',
  'അബ്ദുൽ അസീസ്',
  'പറമ്പത്ത് മറിയം',
  'പുളിയുള്ളതിൽ കുഞ്ഞാമി',
  'മോച്ചാംവീട്ടിൽ ബിയ്യാതു',
  'പീടികക്കണ്ടി അലീമ',
  'മനത്താനത്ത് സുലൈഖ',
  'പാത്തു ചേരാപുരം'
];

export const INITIAL_SECTIONS: SurveySection[] = [
  { id: 'sectionA', label: 'Section A', order: 0, isRepeater: false },
  { id: 'sectionB', label: 'Section B', order: 1, isRepeater: false },
];

// These questions will be loaded into storage if empty
export const INITIAL_QUESTIONS: DynamicQuestion[] = [
  // --- SECTION A ---
  // Serial No is kept for system tracking
  { id: 'serialNo', label: 'ക്രമനമ്പർ (Serial No)', type: 'text', section: 'sectionA', required: true },
  { id: 'familyBranch', label: 'ഏത് കുടുംബത്തിന്റെ ഭാഗമാണ്', type: 'dropdown', section: 'sectionA', options: FAMILY_BRANCHES, required: true },

  // --- SECTION B ---
  { id: 'headName', label: 'കുടുംബ നാഥന്റെ പേര്', type: 'text', section: 'sectionB', required: true },
  { id: 'parentName', label: 'ആരുടെ മകൻ/ മകൾ ആണ്', type: 'text', section: 'sectionB', required: true },
  { id: 'totalMembers', label: 'കുടുംബത്തിലെ ആകെ അംഗങ്ങളുടെ എണ്ണം', type: 'number', section: 'sectionB' },
  { id: 'childrenCount', label: 'കുട്ടികളുടെ എണ്ണം', type: 'number', section: 'sectionB' },
  
  // Added optional photo field to support Card Generation feature
  { id: 'photo', label: 'ഫോട്ടോ (Photo - Optional)', type: 'image', section: 'sectionB' }
];

// Export unused constants to prevent build errors if referenced elsewhere (though unused)
export const HOUSE_OWNERSHIP = [];
export const HOUSE_CONDITION = [];
export const HOUSE_FACILITIES = [];
export const VEHICLES = [];
export const ASSETS = [];
export const AGRICULTURE = [];
export const HEALTH_CONDITIONS = [];
export const SOCIAL_WORK_OPTIONS = [];